import Hero from './components/Hero';
import Stats from './components/Stats';
import Features from './components/Features';
import Scenarios from './components/Scenarios';
import Comics from './components/Comics';
import Ranking from './components/Ranking';
import Timeline from './components/Timeline';
import Reviews from './components/Reviews';
import Faq from './components/Faq';
import Closing from './components/Closing';

export default function Home() {
  return (
    <div className="min-h-screen">
      <Hero />
      <Stats />
      <Features />
      <Scenarios />
      <Comics />
      <Ranking />
      <Timeline />
      <Reviews />
      <Faq />
      <Closing />

      {/* SEO 关键词（不可见但可索引） */}
      <section className="sr-only" aria-hidden="true">
        <p>
          天天漫画是一款优秀的漫画阅读APP，天天漫画下载支持多平台，天天漫画APP下载完全免费，
          天天漫画官方正版下载安全可靠。如果你正在寻找一款好用的漫画阅读软件，天天漫画是你的最佳选择。
        </p>
      </section>
    </div>
  );
}